export enum OnboardingPaths {
  Myself = 'MYSELF',
  Team = 'TEAM',
  Organisation = 'ORGANISATION',
}
